interface GoogleIconProps {
  className?: string;
}

const GoogleIcon = ({ className }: GoogleIconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' className={className}>
    <path fill='#EA4335' d='M24 9.5c3.5 0 6.6 1.2 9.1 3.6l6.8-6.8C35.9 2.5 30.5 0 24 0 14.6 0 6.6 5.5 2.7 13.4l7.9 6.1C12.7 13.2 17.8 9.5 24 9.5z' />
    <path fill='#4285F4' d='M46.6 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.5 5.8c4.4-4 6.9-10 6.9-17.5z' />
    <path fill='#FBBC05' d='M10.6 28.5a14.5 14.5 0 010-9l-7.9-6.1a24 24 0 000 21.2l7.9-6.1z' />
    <path fill='#34A853' d='M24 48c6.5 0 11.9-2.1 15.9-5.8l-7.5-5.8c-2.1 1.4-4.9 2.3-8.4 2.3-6.2 0-11.3-3.7-13.4-9l-7.9 6.1C6.6 42.5 14.6 48 24 48z' />
  </svg>
);

export default GoogleIcon;
